export default () => ({
    storeMenuIsOpen: false,
    accountMenuIsOpen: false
});
